export const LOGO_URL = "/assets/logo.webp";

export const NAV_LINKS = [
  { label: "Ana Sayfa", to: "/" },
  { label: "Araçlarımız", to: "/araclar" },
  { label: "Kampanyalar", to: "/kampanyalar" },
  { label: "Nasıl Çalışır?", to: "/nasil-calisir" },
  { label: "Hakkımızda", to: "/hakkimizda" },
  { label: "SSS", to: "/sss" },
  { label: "İletişim", to: "/iletisim" },
];

export const LOCATIONS = [
  "Taksim",
  "Beyoğlu",
  "Fatih",
  "Tarihi Yarımada",
  "Ümraniye Çarşı",
  "İstanbul Havalimanı",
  "Sabiha Gökçen Havalimanı",
  "Diğer",
];

export const SEGMENTS = [
  { value: "ekonomik", label: "Ekonomik" },
  { value: "orta", label: "Orta Segment" },
  { value: "suv", label: "SUV" },
];

export const TRANSMISSIONS = [
  { value: "otomatik", label: "Otomatik" },
  { value: "manuel", label: "Manuel" },
];

export const FUELS = [
  { value: "benzin", label: "Benzin" },
  { value: "dizel", label: "Dizel" },
  { value: "hibrit", label: "Hibrit" },
];

export const EXTRAS = [
  { id: "child_seat", label: "Çocuk Koltuğu", price: 150 },
  { id: "extra_driver", label: "Ek Sürücü", price: 200 },
  { id: "navigation", label: "Navigasyon", price: 100 },
  { id: "airport_delivery", label: "Havalimanı Teslimatı", price: 400 },
  { id: "extra_km", label: "İlave Kilometre Paketi", price: 250 },
];

export const STATUSES = [
  "Yeni",
  "İletişime Geçildi",
  "Onaylandı",
  "Tamamlandı",
  "İptal",
];

export const STATUS_COLORS = {
  Yeni: "bg-blue-100 text-blue-700",
  "İletişime Geçildi": "bg-amber-100 text-amber-700",
  Onaylandı: "bg-emerald-100 text-emerald-700",
  Tamamlandı: "bg-neutral-200 text-neutral-700",
  İptal: "bg-red-100 text-red-700",
};

export const REGIONS = [
  {
    slug: "taksim",
    path: "/taksim-arac-kiralama",
    name: "Taksim",
    airport: false,
    image:
      "https://images.unsplash.com/photo-1631284666028-9c4ad87281b5?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "Taksim Meydanı ve İstiklal Caddesi çevresinde konforlu araç kiralama. Şehir merkezinde ulaşımı özgürce yönetin.",
    body: "Taksim, İstanbul'un kalbinde yer alır ve iş görüşmelerinden gece hayatına kadar her an hareket halinde olmanızı gerektirir. Voyacar Rent A Car ile Taksim çevresinde aracınızı teslim alarak Beyoğlu, Şişli ve Boğaz hattına kolayca ulaşabilirsiniz. Otoparkı kısıtlı bölgeler için kompakt ekonomik modeller, uzun yol için ise konforlu orta segment ve SUV seçenekleri sunuyoruz.",
    highlights: [
      "İstiklal Caddesi ve meydana yürüme mesafesinde teslim noktaları",
      "Kompakt araçlarla dar sokaklarda kolay park",
      "Boğaz hattına hızlı erişim",
    ],
  },
  {
    slug: "beyoglu",
    path: "/beyoglu-arac-kiralama",
    name: "Beyoğlu",
    airport: false,
    image:
      "https://images.unsplash.com/photo-1621873129944-8d88a5328a0c?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "Beyoğlu ve Galata bölgesinde esnek teslim seçenekleriyle araç kiralayın. Tarihi dokuyu konforla keşfedin.",
    body: "Galata Kulesi, Karaköy ve Cihangir'i kapsayan Beyoğlu, İstanbul'un en canlı bölgelerinden biridir. Voyacar Rent A Car ile Beyoğlu'nda araç kiralayarak hem tarihi sokakları hem de modern yaşam alanlarını rahatça gezebilirsiniz. Trafiğin yoğun olduğu bu bölgede yakıt tasarruflu ve manevra kabiliyeti yüksek modelleri öneriyoruz.",
    highlights: [
      "Galata ve Karaköy çevresinde teslim imkânı",
      "Yakıt tasarruflu ekonomik modeller",
      "Şehir içi kısa mesafeler için ideal",
    ],
  },
  {
    slug: "fatih",
    path: "/fatih-arac-kiralama",
    name: "Fatih",
    airport: false,
    image:
      "https://images.unsplash.com/photo-1622587853578-dd1bf9608d26?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "Fatih bölgesinde bakımlı araçlarla güvenli kiralama. İş ve ziyaret amaçlı ulaşımınızı kolaylaştırın.",
    body: "Fatih, İstanbul'un tarihi ve ticari merkezlerinden biridir. Sirkeci, Aksaray ve Eminönü çevresinde araç kiralamak isteyenler için Voyacar Rent A Car esnek teslim seçenekleri sunar. Bölgedeki yoğun trafik göz önüne alınarak konforlu ve ekonomik araçları bir arada bulabilirsiniz.",
    highlights: [
      "Sirkeci ve Eminönü çevresinde teslim",
      "İş seyahatleri için uygun orta segment araçlar",
      "Tarihi Yarımada'ya kısa mesafe",
    ],
  },
  {
    slug: "tarihi-yarimada",
    path: "/tarihi-yarimada-arac-kiralama",
    name: "Tarihi Yarımada",
    airport: false,
    image:
      "https://images.unsplash.com/photo-1705405412908-9d47956fb596?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "Sultanahmet ve çevresini kapsayan Tarihi Yarımada'da konforlu araç kiralama seçenekleri.",
    body: "Ayasofya, Sultanahmet ve Topkapı Sarayı'nın bulunduğu Tarihi Yarımada, hem turistlerin hem de iş insanlarının yoğun ilgi gösterdiği bir bölgedir. Voyacar Rent A Car ile bu bölgede aracınızı teslim alarak hem şehir içi hem de şehir dışı seyahatlerinizi rahatça planlayabilirsiniz. Dar tarihi sokaklar için kompakt modeller idealdir.",
    highlights: [
      "Sultanahmet çevresinde teslim imkânı",
      "Dar sokaklar için kompakt araçlar",
      "Turistik geziler için konforlu seçenekler",
    ],
  },
  {
    slug: "istanbul-havalimani",
    path: "/istanbul-havalimani-arac-kiralama",
    name: "İstanbul Havalimanı",
    airport: true,
    image:
      "https://images.unsplash.com/photo-1533558701576-23c65e0272fb?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "İstanbul Havalimanı'nda (IST) hızlı ve pürüzsüz araç teslimi. İniş saatinize göre karşılama.",
    body: "İstanbul Havalimanı (IST), Türkiye'nin en büyük havalimanıdır. Voyacar Rent A Car ile uçuş bilgilerinizi paylaşarak iniş saatinize uygun karşılama ve araç teslimi ayarlayabilirsiniz. Uzun yolculuk sonrası konforlu ve bakımlı araçlarla şehir merkezine ya da rotanıza sorunsuz ulaşın.",
    highlights: [
      "Uçuş numarasına göre karşılama",
      "İniş saatine uygun teslim",
      "Terminal çıkışında araç teslimi",
    ],
  },
  {
    slug: "sabiha-gokcen",
    path: "/sabiha-gokcen-arac-kiralama",
    name: "Sabiha Gökçen Havalimanı",
    airport: true,
    image:
      "https://images.unsplash.com/photo-1652509573480-a190f1c61f6d?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "Sabiha Gökçen Havalimanı'nda (SAW) Anadolu Yakası'na kolay ulaşım için araç kiralama.",
    body: "Sabiha Gökçen Havalimanı (SAW), Anadolu Yakası'nın ana ulaşım noktasıdır. Voyacar Rent A Car ile terminal çıkışında aracınızı teslim alarak Kadıköy, Pendik ve çevre bölgelere hızlıca ulaşabilirsiniz. Uçuş numaranızı ve tahmini iniş saatinizi ileterek beklemeden yola çıkabilirsiniz.",
    highlights: [
      "Anadolu Yakası'na hızlı erişim",
      "Uçuş bilgisiyle beklemesiz teslim",
      "Terminal çıkışında karşılama",
    ],
  },
];

export const WHY_VOYACAR = [
  { icon: "sparkles", title: "Bakımlı ve Temiz Araçlar", text: "Her kiralama öncesi detaylı bakım ve temizlikten geçen araçlar." },
  { icon: "zap", title: "Hızlı Rezervasyon", text: "Dakikalar içinde talep oluşturun, WhatsApp'tan anında onaylayın." },
  { icon: "receipt", title: "Şeffaf Süreç", text: "Gizli ücret yok; tüm koşullar rezervasyon öncesi netleştirilir." },
  { icon: "headphones", title: "7/24 Destek", text: "Yolculuğunuz boyunca kesintisiz müşteri desteği." },
  { icon: "map-pin", title: "Esnek Teslim Seçenekleri", text: "Farklı noktalardan alım ve teslim imkânı." },
  { icon: "shield-check", title: "Güvenli Kiralama Süreci", text: "Sigortalı araçlar ve net kiralama koşulları." },
];

export const STEPS = [
  { n: 1, title: "Tarihini ve Konumunu Seç", text: "Alış ve iade tarihini, teslim noktalarını belirle." },
  { n: 2, title: "Aracını Belirle", text: "İhtiyacına en uygun araç sınıfını ve modeli seç." },
  { n: 3, title: "Talebini Gönder ve Yola Çık", text: "Rezervasyon talebini oluştur, ekibimiz seninle iletişime geçsin." },
];

export function fmtPrice(n) {
  return "₺" + Number(n || 0).toLocaleString("tr-TR");
}

export function segmentLabel(v) {
  return { ekonomik: "Ekonomik", orta: "Orta Segment", suv: "SUV" }[v] || v;
}

export function buildWhatsAppUrl(number, message) {
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

export function bookingMessage({ vehicleName, pickup, ret, location }) {
  return `Merhaba VoyaCar Rental, ${vehicleName || "araç"} için ${pickup || "..."}–${ret || "..."} tarihleri arasında araç kiralama teklifi almak istiyorum. Aracı ${location || "..."} konumundan teslim almak istiyorum.`;
}

export function formatDateTimeTR(value) {
  if (!value) return "";
  try {
    const d = new Date(value);
    return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return value;
  }
}

export function computeDays(pickup, ret) {
  if (!pickup || !ret) return 1;
  const diff = new Date(ret) - new Date(pickup);
  if (diff <= 0) return 1;
  return Math.max(1, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}
